import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

const version = import.meta.env.VITE_VERSION || "unknown";
const applicationId = import.meta.env.VITE_DD_RUM_APPLICATION_ID;
const clientToken = import.meta.env.VITE_DD_RUM_CLIENT_TOKEN;
const service = import.meta.env.VITE_DD_SERVICE;
const env = import.meta.env.VITE_DD_ENV;
const sessionSampleRate = Number(
  import.meta.env.VITE_DD_SESSION_SAMPLE_RATE || 100,
);
const sessionReplaySampleRate = Number(
  import.meta.env.VITE_DD_SESSION_REPLAY_SAMPLE_RATE || 0,
);
const allowedTracingUrls = (import.meta.env.VITE_DD_ALLOWED_TRACING_URLS || "")
  .split(",")
  .filter(Boolean);

const THIRD_PARTY_URLS: RegExp[] = [
  /fonts\.googleapis\.com/,
  /js\.stripe\.com/,
  /www\.googletagmanager\.com/,
  /static\.userback\.io/,
  /api\.userback\.io/,
  /cdn\.segment\.com/,
  /api\.segment\.io/,
  /prodregistryv2\.org/,
  /featureassets\.org/,
];

if (import.meta.env.VITE_DD_RUM_ENABLED === "true") {
  datadogRum.init({
    applicationId,
    clientToken,
    site: "us5.datadoghq.com",
    traceSampleRate: 25,
    service,
    env,

    // Specify a version number to identify the deployed version of your application in Datadog
    version,
    sessionSampleRate,
    sessionReplaySampleRate,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    plugins: [reactPlugin({ router: false })],
    excludedActivityUrls: THIRD_PARTY_URLS,
    beforeSend: (event) => {
      if (
        event.type === "resource" &&
        THIRD_PARTY_URLS.some((pattern) =>
          pattern.test(
            (event as { resource?: { url?: string } }).resource?.url ?? "",
          ),
        )
      ) {
        return false;
      }
      return true;
    },
  });
}
